import React, { Component } from 'react'
import PropTypes from 'prop-types'

export class Numeric extends Component {

    static propTypes = {
        value: PropTypes.number.isRequired,
    }

    render() {
        const { value } = this.props

        return (
            <span title={ value }>
                { value }
            </span>
        )
    }
}
